import { ScrollView, View } from 'react-native';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { WorkoutsHeader } from '~/workout/components/workouts-header/WorkoutsHeader';
import { WorkoutHistorySection } from '~/workout/components/workout-history-section/WorkoutHistorySection';
import { ExerciseLibrarySection } from '~/sport-activity/components/exercise-library-section/ExerciseLibrarySection';
import { WorkoutStatsSection } from '~/workout/components/workout-stats-section/WorkoutStatsSection';
import { PersonalRecordsSection } from '~/workout/components/personal-records-section/PersonalRecordsSection';

export interface WorkoutsScreenProps {}

export const WorkoutsScreen = ({}: WorkoutsScreenProps) => {
  return (
    <FullHeightWrapper>
      <WorkoutsHeader />
      <ScrollView className="flex-1" showsVerticalScrollIndicator={false}>
        <View className="p-8 gap-6">
          <WorkoutsHeader.Body className="md:hidden" />
          <View className="flex flex-col gap-6 md:flex-row">
            <View className="flex flex-col gap-6 md:flex-1">
              <WorkoutHistorySection />
              <ExerciseLibrarySection />
            </View>
            <View className="flex flex-col gap-6 md:flex-1">
              <WorkoutStatsSection />
              <PersonalRecordsSection />
            </View>
          </View>
        </View>
      </ScrollView>
    </FullHeightWrapper>
  );
};
